export enum TooltipTestIds {
  ROOT = 'tooltip-root',
  TITLE = 'tooltip-title',
  TEXT = 'tooltip-text',
  AVATAR = 'tooltip-avatar',
  FALLBACK_AVATAR = 'tooltip-fallback-avatar',
  AVATAR_BADGE_IS_LIVE = 'tooltip-avatar-badge-is-live',
  AVATAR_BADGE_WAS_LIVE = 'tooltip-avatar-badge-was-live',
  USER_NAME = 'tooltip-user-name',
}
